import { convert } from 'html-to-text';

import { isMarkupWithoutText } from '@/common/helpers/isMarkupWithoutText/isMarkupWithoutText';
import { ShareActionType, SocialShareActionType } from '@/forwarding/constants/ShareActionType';

export function createShareInfoText(title: string, description: string, linksText: string): string {
  if (!linksText) {
    return '';
  }

  if (isMarkupWithoutText(description)) {
    return `${title}\n${linksText}`;
  }

  const plainTextDescription = convert(description, { wordwrap: false }).replace(/\n+/g, '\n');

  return `${title}\n${plainTextDescription}\n${linksText}`;
}

export function getMailSubject(title: string): string {
  return `${title} from cutwise.com`;
}

export function createSocialShareUrl(type: SocialShareActionType, content: string): string {
  const encodedContent = encodeURIComponent(content);

  switch (type) {
    case ShareActionType.WhatsApp:
      return `https://wa.me/?text=${encodedContent}`;
    case ShareActionType.Facebook:
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedContent}`;
    case ShareActionType.Twitter:
      return `https://twitter.com/intent/tweet?url=${encodedContent}`;
    case ShareActionType.Pinterest:
      return `https://pinterest.com/pin/create/button/?url=${encodedContent}&media=${encodedContent}`;
  }
}
